
/* injects from baggage-loader */
require('./style.scss');

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Config from '../../../config/main';
import BetBuilder from '@external/BetBuilder';
import { useState } from 'react';
import BetBuliderBetslip from './components/betslip';

const BetBuilderWrapper = ({ sportcastId, language, oddsFormat }) => {
    const [betData, setBetData] = useState(null);

    const onUpdate = (command, data) => {
        const commandMap = {
            addToBetslip: () => setBetData(data),
        };

        commandMap[command]?.();
    };

    return <>
        <BetBuilder
            sportcastId={sportcastId}
            language={language}
            oddsFormat={oddsFormat}
            skinConfig={Config.betBuilder}
            updateHandler={onUpdate}
        />

        {betData && <div className="bet-builder-betslip-wrapper">
            <BetBuliderBetslip betData={betData} onClear={() => setBetData(null)} />
        </div>}
    </>;
};

BetBuilderWrapper.propTypes = {
    sportcastId: PropTypes.number.isRequired,
};

const mapStateToProps = store => ({
    language: store.preferences.lang,
    oddsFormat: store.uiState.oddsFormat,
});

export default connect(mapStateToProps)(BetBuilderWrapper);